/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs */

const en_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum Characters/Line`)
};

const fr_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteres maximum par ligne`)
};

const de_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximale Zeichen pro Zeile`)
};

const it_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numero massimo di caratteri/riga`)
};

const ru_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимальное количество символов в строке`)
};

const es_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de caracteres/línea`)
};

const zh_cn2_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每行最大字符数`)
};

const ja_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大文字数/行`)
};

const hi_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रति पंक्ति अधिकतम अक्षर`)
};

const pt_pt2_style_guide_manager_max_characters_per_line_label = /** @type {(inputs: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Número máximo de caracteres por linha`)
};

/**
* | output |
* | --- |
* | "Maximum Characters/Line" |
*
* @param {Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_max_characters_per_line_label = /** @type {((inputs?: Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Max_Characters_Per_Line_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "de") return de_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "it") return it_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "es") return es_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_max_characters_per_line_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_max_characters_per_line_label(inputs)
	return en_style_guide_manager_max_characters_per_line_label(inputs)
});